module.exports = __webpack_public_path__ + "static/media/keyword-in-image-alt-text.f068d272.svg";